<h1 mat-dialog-title>{{ 'Delete iSCSI extent {name}?' | translate: { name: extent.name } }}</h1>
<div mat-dialog-content>
  <form [formGroup]="form">
    <ix-checkbox
      *ngIf="isFile"
      formControlName="remove"
      [label]="'Remove file?' | translate"
    ></ix-checkbox>
    <ix-checkbox
      formControlName="force"
      [label]="'Force' | translate"
    ></ix-checkbox>
  </form>
</div>
<ix-form-actions mat-dialog-actions class="form-actions">
  <button
    mat-button
    ixTest="cancel"
    [matDialogClose]="false"
  >
    {{ 'Cancel' | translate }}
  </button>
  <button
    *ixRequiresRoles="requiredRoles"
    mat-button
    color="primary"
    ixTest="delete"
    (click)="onDelete()"
  >
    {{ 'Delete' | translate }}
  </button>
</ix-form-actions>
